module.exports = __webpack_public_path__ + "img/iis.24dad3d3.svg";